import { useAddToast } from '../../../../contexts/ToastContext';
import { useToastedMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';

type ResendResponse = { sent: boolean };

type UseResendEmailVerificationOptions = {
  /**
   * Called when the backend silently skipped sending, typically because the
   * user got verified in another tab. The banner uses this to dismiss itself
   * without a misleading "email sent" toast.
   */
  onSkipped?: () => void;
};

/**
 * Send the verification email for the currently authenticated user
 */
export function useResendEmailVerification(options: UseResendEmailVerificationOptions = {}) {
  const addToast = useAddToast();
  return useToastedMutation({
    mutationFn: async () => {
      return post<never, ResendResponse>('/api/auth/email/resend', undefined as never);
    },
    onSuccess: (response) => {
      if (response.data?.sent) {
        addToast({ type: 'success', content: 'Verification email sent. Check your inbox.' });
      } else {
        options.onSkipped?.();
      }
    },
    errorToastMessage: 'Failed to send verification email. Please try again.',
  });
}
